const hashRegex = /^#dal(.+)/gm;

const getDelfiHashTracker = (hash: string) => {
  const m = hashRegex.exec(hash) || [];
  return m[1] ?? null;
};

export default getDelfiHashTracker;
